module.exports = __webpack_public_path__ + "ipetbooking/admin/img/service-icon.c5b60c4d.svg";